module.exports = __webpack_public_path__ + "media/sweepstakes_and_promotions/contest_01-124cb480.png";